import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import TournamentsPage from "@/pages/TournamentsPage";
import TournamentDetailPage from "@/pages/TournamentDetailPage";
import PlayersPage from "@/pages/PlayersPage";
import PlayerProfilePage from "@/pages/PlayerProfilePage";
import RankingsPage from "@/pages/RankingsPage";
import ClubsPage from "@/pages/ClubsPage";
import CoachesPage from "@/pages/CoachesPage";
import VideosPage from "@/pages/VideosPage";
import NewsPage from "@/pages/NewsPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import SponsorsPage from "@/pages/SponsorsPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import RegisterClubPage from "@/pages/RegisterClubPage";
import ClubDashboardPage from "@/pages/ClubDashboardPage";
import OrganizerHubPage from "@/pages/OrganizerHubPage";
import RefereeDashboardPage from "@/pages/RefereeDashboardPage";
import RefereeLoginPage from "@/pages/RefereeLoginPage";
import QuickJoinPage from "@/pages/QuickJoinPage";
import JoinTournamentPage from "@/pages/JoinTournamentPage";
import DashboardPage from "@/pages/DashboardPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/tournaments" element={<TournamentsPage />} />
        <Route path="/tournaments/:id" element={<TournamentDetailPage />} />
        <Route path="/players" element={<PlayersPage />} />
        <Route path="/players/:id" element={<PlayerProfilePage />} />
        <Route path="/rankings" element={<RankingsPage />} />
        <Route path="/clubs" element={<ClubsPage />} />
        <Route path="/coaches" element={<CoachesPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/sponsors" element={<SponsorsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register-club" element={<RegisterClubPage />} />
        <Route path="/club/dashboard" element={<ProtectedRoute><ClubDashboardPage /></ProtectedRoute>} />
        <Route path="/organizer/tournaments/:id" element={<ProtectedRoute><OrganizerHubPage /></ProtectedRoute>} />
        <Route path="/referee/login" element={<RefereeLoginPage />} />
        <Route path="/referee/dashboard" element={<ProtectedRoute><RefereeDashboardPage /></ProtectedRoute>} />
        <Route path="/tournaments/:id/join" element={<JoinTournamentPage />} />
        <Route path="/tournaments/:id/quick-join" element={<QuickJoinPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/dashboard" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
